module.exports = __webpack_public_path__ + "img/stateTwoPass.c943aeb1.png";